import { connect } from 'react-redux';
import { removeNotification } from './redux/actionCreators';
import { getNotificationQueue } from './redux/selectors';
const mapStateToProps = (state, ownProps)=>({
        queue: getNotificationQueue(state, ownProps.queueName)
    });
const mapDispatchToProps = {
    removeNotification
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=Notifications.container.js.map